import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "hidden sm:block text-xl" }
const _hoisted_2 = {
  key: 0,
  class: "grid grid-cols-[max-content_max-content] items-center justify-between gap-y-2 pt-2"
}
const _hoisted_3 = { class: "text-sm text-left" }
const _hoisted_4 = { class: "text-sm text-left" }
const _hoisted_5 = { class: "text-sm text-left" }

import { useI18n } from "vue-i18n";
import { ref } from "vue";
import AppSelect from "@/components/inputs/AppSelect.vue";
import CheckBox from "@/components/inputs/CheckBox.vue";
import CogIcon from "@/components/icons/CogIcon.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'FlyingStarsControls',
  emits: ["update:yearStars", "update:monthStars", "update:buildYear", "toggle:showStars"],
  setup(__props, { emit: __emit }) {

const calendarYears = Array.from({ length: 200 }, (_, i) => 1901 + i);
const calendarMonths = [
  "tiger",
  "rabbit",
  "dragon",
  "snake",
  "horse",
  "goat",
  "monkey",
  "rooster",
  "dog",
  "pig",
  "rat",
  "ox",
];

const { t } = useI18n();

const emits = __emit;

const showStars = ref<boolean>(false);
const showStarsControls = ref<boolean>(false);
const buildYear = ref<number>(new Date().getFullYear());
const yearStars = ref<number>(new Date().getFullYear());
const monthStars = ref<number>(new Date().getMonth());

function handleChangeYear(year: number): void {
  yearStars.value = year;
  emits("update:yearStars", year, monthStars.value + 1);
}

function handleChangeMonth(month: string): void {
  monthStars.value = calendarMonths.indexOf(month);
  emits("update:monthStars", yearStars.value, monthStars.value + 1);
}

function handleBuildYear(year: number) {
  buildYear.value = year;
  emits("update:buildYear", Number(year));
}

function toggleShowSettings() {
  showStarsControls.value = !showStarsControls.value;
}

function toggleShowStars() {
  showStars.value = !showStars.value;
  emits(
    "toggle:showStars",
    showStars.value,
    buildYear.value,
    yearStars.value,
    monthStars.value
  );
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([
      'flex-col m-[10px] p-3 rounded-xl bg-white flex absolute top-0 left-0 z-[1001] overflow-hidden',
      'transition-all duration-300 ease-in-out',
      showStarsControls.value ? 'w-[278px]' : 'w-12 sm:w-[200px]',
    ])
  }, [
    _createElementVNode("button", {
      class: "w-full flex items-center justify-between",
      onClick: toggleShowSettings
    }, [
      _createVNode(CogIcon, { class: "sm:hidden size-6" }),
      _createElementVNode("span", _hoisted_1, _toDisplayString(_unref(t)("calculators.azm.flying-stars")), 1),
      (_openBlock(), _createElementBlock("svg", {
        class: _normalizeClass([
          'size-8 transform transition-transform hidden sm:block',
          showStarsControls.value ? 'rotate-180' : 'rotate-0',
        ]),
        fill: "none",
        stroke: "currentColor",
        viewBox: "0 0 24 24"
      }, [...(_cache[2] || (_cache[2] = [
        _createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M19 9l-7 7-7-7"
        }, null, -1)
      ]))], 2))
    ]),
    (showStarsControls.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("p", _hoisted_3, _toDisplayString(_unref(t)("calculators.azm.year-stars")), 1),
          _createVNode(AppSelect, {
            class: "w-[140px]",
            items: _unref(calendarYears),
            "default-value": yearStars.value,
            onSelectOption: _cache[0] || (_cache[0] = (year) => handleChangeYear(Number(year)))
          }, null, 8, ["items", "default-value"]),
          _createElementVNode("p", _hoisted_4, _toDisplayString(_unref(t)("calculators.azm.month-stars")), 1),
          _createVNode(AppSelect, {
            class: "w-[140px]",
            items: calendarMonths,
            "default-value": calendarMonths[monthStars.value],
            onSelectOption: _cache[1] || (_cache[1] = (month) => handleChangeMonth(month))
          }, {
            option: _withCtx(({ item }) => [
              _createTextVNode(_toDisplayString(_unref(t)(`calculators.azm.months.${item}`)), 1)
            ]),
            _: 1
          }, 8, ["default-value"]),
          _createElementVNode("p", _hoisted_5, _toDisplayString(_unref(t)("labels.build-year")), 1),
          _createVNode(AppSelect, {
            class: "w-[140px]",
            items: _unref(calendarYears),
            "default-value": buildYear.value,
            onSelectOption: handleBuildYear
          }, null, 8, ["items", "default-value"]),
          _createVNode(CheckBox, {
            class: "col-span-2",
            "input-id": "move-image",
            label: _unref(t)('calculators.azm.show-flying-stars'),
            isEnabled: showStars.value,
            onToggle: toggleShowStars
          }, null, 8, ["label", "isEnabled"])
        ]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})